export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'admin',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'dashboard',
      },
    },
    {
      name: 'stores',
      displayName: 'menu.stores',
      meta: {
        icon: 'storefront',
      },
    },
    {
      name: 'jrs-manager',
      displayName: 'menu.jrs',
      meta: {
        icon: 'vuestic-iconset-files',
      },
    },
    {
      name: 'promotions',
      displayName: 'menu.promotions',
      meta: {
        icon: 'campaign',
      },
    },
    // {
    //   name: 'ads',
    //   displayName: 'menu.ads',
    //   meta: {
    //     icon: 'ads_click',
    //   },
    //   children: [
    //     {
    //       name: 'jrs-ads',
    //       displayName: 'menu.jrs-ads',
    //     },
    //     {
    //       name: 'alarm-ads',
    //       displayName: 'menu.alarm-ads',
    //     },
    //     {
    //       name: 'search-suggestion-ads',
    //       displayName: 'menu.search-suggestion-ads',
    //     },
    //     {
    //       name: 'search-sns-ads',
    //       displayName: 'menu.search-sns-ads',
    //     },
    //   ],
    // },
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        icon: 'credit_card',
      },
    },
    {
      name: 'payments',
      displayName: 'menu.payments',
      meta: {
        icon: 'mso-receipt_long',
      },
    },
    {
      name: 'faq',
      displayName: 'menu.faq',
      meta: {
        icon: 'quiz',
      },
    },
    {
      name: 'notice',
      displayName: 'menu.notice',
      meta: {
        icon: 'info',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
